module.exports = __webpack_public_path__ + "97b34e9839ac1dad19c6b5835efb2376.jpg";